import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { PAYMENT_METHODS_QUERY } from '../usePaymentMethodsQuery';
import { DELETE_PAYMENT_METHOD_MUTATION } from './deletePaymentMethodMutation.rest';

export const useDeletePaymentMethodMutation = (id: string) => {
  const [mutate, { loading, error }] = useMutation(DELETE_PAYMENT_METHOD_MUTATION, {
    update: (cache, { data }) => {
      if (!data) return;

      const cachedData = cache.readQuery({ query: PAYMENT_METHODS_QUERY });

      if (!cachedData) return;

      cache.writeQuery({
        query: PAYMENT_METHODS_QUERY,
        data: {
          paymentMethods: {
            __typename: 'RestPaymentMethods',
            data: cachedData.paymentMethods.data.filter(method => method.id !== id)
          }
        }
      });
    }
  });

  const handleDelete = useCallback(() => {
    return mutate({ variables: { id } });
  }, [mutate, id]);

  return [handleDelete, { loading, error }] as const;
};
